import { updateLinksAttributes } from '../utils/handleAttributes';

export default function headerButtons(
  widgetNameVariable,
  widgetOptsVariable,
  maxItemsVisibleVariable,
) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: maxItemsVisibleVariable,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomBtn(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomBtn(widgetData) {
    const items = widgetData.items;

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = items[x];

      if (URL == null) {
        $(this).remove();
      } else {
        $(this).replaceWith(
          `<a class="button ${widgetName}" tabindex="0" href="${URL}" ${updateLinksAttributes(URL, Title)}>${Title}</a>`,
        );
      }
    });
  }
}
